import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
import { toast } from "@/lib/use-toast";
interface UseDTMFOptions {
  call: {
    sendDigits: (digits: string) => Promise<void>;
  } | null;
  isCallActive?: () => boolean;
}
interface UseDTMFReturn {
  dialedDigits: string;
  sendDTMF: (digits: string) => Promise<void>;
  resetDialedDigits: () => void;
}
export function useDTMF(t0) {
  const $ = _c(7);
  const {
    call,
    isCallActive
  } = t0;
  const [dialedDigits, setDialedDigits] = useState("");
  let t1;
  if ($[0] !== call || $[1] !== isCallActive) {
    t1 = async digits => {
      if (!call || isCallActive && !isCallActive()) {
        toast({
          title: "Cannot Send DTMF",
          description: "Call must be active to send DTMF tones.",
          variant: "error"
        });
        return;
      }
      ;
      try {
        await call.sendDigits(digits);
        setDialedDigits(prev => prev + digits);
      } catch (t2) {
        const error = t2;
        console.error("Error sending DTMF:", error);
        toast({
          title: "DTMF Error",
          description: "Failed to send DTMF tones. Please try again.",
          variant: "error"
        });
      }
    };
    $[0] = call;
    $[1] = isCallActive;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sendDTMF = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setDialedDigits("");
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const resetDialedDigits = t2;
  let t3;
  if ($[4] !== dialedDigits || $[5] !== sendDTMF) {
    t3 = {
      dialedDigits,
      sendDTMF,
      resetDialedDigits
    };
    $[4] = dialedDigits;
    $[5] = sendDTMF;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}